import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import UserCreate from "../components/UserCreate/UserCreate";
import { createUser } from "../actions/usercreate";
import { fetchUserInfo } from "../actions/user";

const mapStateToProps = (state) => {
  return {
    isFetching: state.userCreate.isFetching,
    response: state.userCreate.response,
    error: state.userCreate.error,

    user_info: state.login.user_info,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createUser,
      fetchUserInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserCreate);
